export { Category } from '../gql/graphql'
import { Category } from '../gql/graphql'

// Human-readable display names for each category enum value
export const CATEGORY_DISPLAY: Record<string, string> = {
  [Category.Groceries]:        'Groceries',
  [Category.Food]:             'Food',
  [Category.Transportation]:   'Transportation',
  [Category.Apparel]:          'Apparel',
  [Category.Retail]:           'Retail',
  [Category.Entertainment]:    'Entertainment',
  [Category.HealthAndFitness]: 'Health & Fitness',
  [Category.Housing]:          'Housing',
  [Category.Utilities]:        'Utilities',
  [Category.Travel]:           'Travel',
  [Category.Other]:            'Other',
  [Category.Tax]:              'Tax',
}

export const CATEGORY_EMOJIS: Record<string, string> = {
  [Category.Groceries]:        '🛒',
  [Category.Food]:             '🍽️',
  [Category.Transportation]:   '🚗',
  [Category.Apparel]:          '👕',
  [Category.Retail]:           '🛍️',
  [Category.Entertainment]:    '🎬',
  [Category.HealthAndFitness]: '💪',
  [Category.Housing]:          '🏠',
  [Category.Utilities]:        '💡',
  [Category.Travel]:           '✈️',
  [Category.Other]:            '📦',
  [Category.Tax]:              '🧾',
}
